import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "isBtnLinkValid",
  standalone: true,
})
export class IsBtnLinkValidPipe implements PipeTransform {
  public transform(contents: any): any {
    const nestedContentField = contents.find(
      (field) => field.name === "ButtonLink",
    );
    return !!nestedContentField?.contentFieldValue?.data;
  }
}
